import React, { useState } from "react"
import SourceModal from "../LeadSource/SourceModal"
import WebsiteModal from "./modal-website"
import SweetAlert from "react-bootstrap-sweetalert"

const FetchWebsite = props => {
  const [fetch, setFetch] = useState(props.data)
   const [confirm_alert, setconfirm_alert] = useState(false)
    const [success_dlg, setsuccess_dlg] = useState(false)
    const [dynamic_title, setdynamic_title] = useState("")
    const [dynamic_description, setdynamic_description] = useState("")
  const [isOpen, setIsOpen] = useState(false)
  const [modal_standard, setmodal_standard] = useState(false)

  const editFetch = () => {
    setIsOpen(true)
    setmodal_standard(true)
  }

  if (fetch === "") {
    return ""
  } else
    return (
      <>
        {isOpen ? (
          <WebsiteModal
            modal_lead_source={modal_standard}
            setmodal_lead_source={setmodal_standard}
            source={fetch}
            setSource={setFetch}
            setIsOpen={setIsOpen}
            fetch_from_web={true}
          />
        ) : null}
        <tr key={props.i}>
          <td>{props.counter + props.i}</td>
          <td>{fetch.name}</td>
          <td>{fetch.total}</td>
          <td>
            {fetch.assigneename?.map((item, i) => (
              <span key={i}>
                {item.name}
                <br />
              </span>
            ))}
          </td>
          <td>
            <a
              className="text-warning"
              onClick={() => {
                editFetch(fetch.id)
              }}
            >
              <i className="fas fa-pen" />
            </a>
                      <a
                        className="text-danger ms-2"
                        onClick={() => {
                          setconfirm_alert(true)
                        }}
                      >
                        <i className="fas fa-trash-alt" />
                      </a>
                      {confirm_alert ? (
                        <SweetAlert
                          title="Are you sure?"
                          warning
                          showCancel
                          confirmButtonText="Yes, delete it!"
                          confirmBtnBsStyle="success"
                          cancelBtnBsStyle="danger"
                          // onConfirm={() => {
                          //   setconfirm_alert(false)
                          //   setsuccess_dlg(true)
                          //   deleteFetch(fetch.id)
                          //   setdynamic_title("Deleted")
                          //   setdynamic_description("Your file has been deleted.")
                          // }}
                          onConfirm={() => {
                            setconfirm_alert(false)}
                          }
                          onCancel={() => setconfirm_alert(false)}
                        >
                          You won't be able to revert this!
                        </SweetAlert>
                      ) : null}
          </td>
        </tr>
      </>
    )
}
export default FetchWebsite
